import Layout from '@/layout'
import NotFound from 'views/exception/404'
import creditApprovalRouter from './creditApprovalRouter'
import settingRouter from './settingRouter'
import sysRouter from './sysRouter'
import itemRouter from './itemRouter'
import clientRouter from './clientRouter'
import customerCreditRouter from './customerCreditRouter'
import exceptionRouter from './exception'
import sassRouter from './sassRouter'
const routes = [
  {
    path: '/',
    name: 'index',
    component: Layout,
    redirect: '/login',
    children: [
      {
        path: 'personal',
        name: 'personal',
        meta: { extra: true },
        component: () =>
          import(/* webpackChunkName: 'personal' */ 'views/personal'),
      },
      // 文件管理
      {
        path: 'file-management',
        component: { render: h => h('router-view') },
        children: [
          {
            path: '/file-management/public-file',
            name: 'public-file',
            component: () =>
              import(
                /* webpackChunkName: "file-management" */ 'views/file-management/public-file'
              ),
          },
        ],
      },
      creditApprovalRouter,
      settingRouter,
      itemRouter,
      clientRouter,
      sysRouter,
      customerCreditRouter,
      exceptionRouter,
      sassRouter,
      // {
      //   path: '*',
      //   component: NotFound
      // }
    ],
  },
  {
    path: '/old-login',
    name: 'old-login',
    component: () => import('views/old-login'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ 'views/login'),
  },
  {
    path: '/reset-psw',
    name: 'reset-psw',
    component: () =>
      import(/* webpackChunkName: "reset-psw" */ 'views/login/reset-psw'),
  },
  {
    path: '/loginOut',
    name: 'loginOut',
    component: () =>
      import(/* webpackChunkName: "reset-psw" */ 'views/loginOut'),
  },
  {
    path: '*',
    name: '404',
    component: NotFound,
  },
]

export default routes
